import { MouseEvent } from 'react';
import type { SxProps } from '@mui/system';

export const stopPropagation = (e: MouseEvent<HTMLElement>) => {
  e.stopPropagation();
};

export const noop = () => {};

export const getErrorMessageFromException = (e: any) => {
  const message = e?.details?.message;
  if (Array.isArray(message)) {
    return message.join(',');
  }
  if (message) {
    return message;
  }
  return 'Something Went Wrong';
};

export function isValidLatLng(lat: number, lng: number): boolean {
  if (Number.isNaN(lat) || Number.isNaN(lng)) {
    return false;
  }
  if (lat < -90 || lat > 90) {
    return false;
  }
  if (lng < -180 || lng > 180) {
    return false;
  }
  return true;
}

export function formatLatLng(lat: number, lng: number, fractionDigits = 6) {
  if (!lat || !lng) {
    return 'N/A';
  }
  return `${lat.toFixed(fractionDigits)}, ${lng.toFixed(fractionDigits)}`;
}

type PureSx<T extends object> = Exclude<SxProps<T>, ReadonlyArray<unknown>>;
type SxAsArray<T extends object> = Array<PureSx<T>>;

export const mergeSX = <T extends object>(
  ...styles: (SxProps<T> | false | undefined)[]
): SxProps<T> => {
  const capacitor: SxAsArray<T> = [];

  styles.forEach((sx) => {
    if (sx) {
      if (Array.isArray(sx)) {
        (sx as SxAsArray<T>).forEach((s) => capacitor.push(s));
      } else {
        capacitor.push(sx as PureSx<T>);
      }
    }
  });

  return capacitor;
};

export const isUnauthorized = (status: number): boolean => status === 401;
